/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/
import { useEffect, useState } from "react";
import * as THREE from "three";
import React, { useRef } from "react";
import { Html, Plane, Text, useGLTF } from "@react-three/drei";
import { GLTF } from "three-stdlib";
import { useMediaQuery } from "@mui/material";

type GLTFResult = GLTF & {
  nodes: {
    Circle001: THREE.Mesh;
    Cylinder: THREE.Mesh;
    Torus: THREE.Mesh;
  };
  materials: {
    ["Material.001"]: THREE.MeshStandardMaterial;
    Material: THREE.MeshStandardMaterial;
  };
};

export function ComingSoonModel(props: any) {
  //@ts-ignore
  const { nodes, materials } = useGLTF("/product_outline.glb") as GLTFResult;

  const matches = useMediaQuery("(min-width:600px)");

  const ref: any = useRef();

  const [hover, setHover] = useState(false);



  useEffect(() => {
    if (ref.current) {
      ref.current.lookAt(0, 0, 0);
    }
  }, []);

  useEffect(() => {
    document.body.style.cursor = hover ? "pointer" : "grab";
  }, [hover]);

  return (
    <group
      ref={ref}
      {...props}
      onPointerOver={() => {
        props.setOpen(true);
        setHover(true);
      }}
      onPointerOut={() => {
        props.setOpen(false);
        setHover(false);
      }}
      onClick={() => props.onClick()}
      dispose={null}
    >
      {matches ? (
        <></>
      ) : (
        <mesh
          geometry={new THREE.SphereGeometry(8, 16, 8)}
          material={
            new THREE.MeshBasicMaterial({
              // color: 0xaaaaaa,
              // wireframe: true,
              visible: false,
            })
          }
          position={[0, 0, 0]}
          scale={1}
        />
      )}
      {/* {props.open && (
        <mesh position={[0, 5, 0]}>
          <Plane
            args={[15, 5]}
            position={[0, 0, -2]}
            material-color="0xffffff"
          />
          <Text
            color="black"
            anchorX="center"
            anchorY="middle"
            position={[0, 0, 0]}
            fontSize={2}
            ref={ref}
            font={`${process.env.PUBLIC_URL}/Lora.json`}
          >
            Coming Soon
          </Text>
          {/* <Html>
            <Paper
              sx={{
                heigh: "100%",
                width: "100%",
                minWidth: "200px",
                maxWidth: "900px",
                padding: "10px",
                pointer: "default",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: 0,
              }}
              // onPointerOver={() => setHover(true)}
              // onPointerOut={() => setHover(false)}
            >
              <Typography
                variant={"h6"}
                sx={{ fontSize: "1em" }}
                align="center"
              >
                Coming soon
              </Typography>
            </Paper>
          </Html> 
        </mesh>
      )} */}
      <mesh
        geometry={nodes.Circle001.geometry}
        material={
          new THREE.MeshBasicMaterial({
            color: 0x000000,
            opacity: 0.2,
            transparent: true,
          })
        }
        position={[0, -0.1, -0.1]}
        rotation={[Math.PI / 2, 0, 0]}
      />
      <mesh
        geometry={nodes.Cylinder.geometry}
        material={
          new THREE.MeshBasicMaterial({
            color: 0xffffff,
            opacity: 0.5,
            transparent: true,
          })
        }
        position={[0.01, -0.02, 0]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[1, 0.04, 1]}
      />
      {hover && (
        <mesh
          geometry={nodes.Torus.geometry}
          material={materials.Material}
          position={[0, 0, -0.1]}
          rotation={[Math.PI / 2, 0, 0]}
          scale={[2.09, 0.47, 2.09]}
        />
      )}
    </group>
  );
}

useGLTF.preload("/product_outline.glb");
